export default {
  'goldkid-rejectAB:title': 'Балаға арналған Kaspi Gold ашылып койды. Картаны алыңыз.',
  'goldkid-rejectAB-steps:title': 'Балаға арналған Kaspi Gold картасын алу немесе қайта шығару үшін',
  'goldkid-rejectAB-steps:step1': '<b>Ата-ана</b> кез келген Kaspi.kz <a href="https://kaspi.kz/maps/branches/?has_cardomat=True&closest=True"> бөлімшесіне барып;</a>',
  'goldkid-rejectAB-steps:step2': 'Kaspi Gold картасын Kaspi QR көмегімен картоматтан алып;',
  'goldkid-rejectAB-steps:step3': 'Карта мен PIN-кодты <b>балаға береді.</b>',
  'goldkid-rejectAB:btn': 'Ең жақын Kaspi бөлімшесі'
}
